import { useEffect, useState } from "react";
import Top from "./Top";
import Right from "./Right";
import { getUserFromToken } from "../../function";
import { server } from "../../server";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/profileSlice";
import { Link } from "react-router-dom";

function Settings() {
  const dispatch = useDispatch();
  const token = localStorage.getItem("authToken");
  const user = getUserFromToken();
  const { user: profileData, error } = useSelector((state) => state.profile);
  const [profile, setProfile] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
  });

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (profileData) {
      setProfile({
        name: profileData.name || "",
        email: profileData.email || "",
        phone: profileData.phone || "",
        address: profileData.address || "",
      });
    }
  }, [profileData]);

  useEffect(() => {
    if (user?._id) {
      dispatch(fetchUserProfile({ userId: user._id, token }));
    }
  }, [user?._id, token, dispatch]);

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    try {
      setSaving(true);
      setMessage("");

      const response = await fetch(`${server}/Profile/UpdateProfile`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          id: user?._id,
          name: profile.name,
          email: profile.email,
          address: profile.address,
        }),
      });

      if (!response.ok) throw new Error("Update failed");

      setMessage("✅ Profile updated successfully!");
    } catch (error) {
      setMessage("❌ Failed to update profile.");
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <main>
        <Top />

        <div className="container">
          <div className="row g-3">
            <div className="col-lg-9 col-12 py-2">
              <section class="position-relative z-1">
                <div className="pb-3 d-flex flex-column flex-md-row gap-0 align-items-md-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <Link
                      to="/all-events"
                      className="action-button-md bg-white-transparent rounded-circle"
                    >
                      <i className="bi bi-arrow-left fs-4 text-dark"></i>
                    </Link>
                    <div>
                      <h1 className="mb-0 h4 text-light lh-1 fw-medium ms-3">
                        Account Settings
                      </h1>
                      <nav aria-label="breadcrumb" className="m-0 ms-3">
                        <ol className="breadcrumb">
                          <li className="breadcrumb-item">
                            <span>Home</span>
                          </li>
                          <li
                            className="breadcrumb-item active"
                            aria-current="page"
                          >
                            Profile Settings
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </section>

              <section className="position-relative z-1 pt-1">
                <div className="row g-2">
                  <div className="col-lg-7 col-12">
                    <div className="bg-white rounded-4 p-5 rounded-4">
                      {loading ? (
                        <div className="text-center py-5">
                          <div
                            className="spinner-border text-dark"
                            role="status"
                          ></div>
                        </div>
                      ) : (
                        <form onSubmit={handleUpdateProfile}>
                          <div className="row g-2">
                            <div className="col-12 mb-2">
                              <h5 className="m-0 lh-1">
                                <i className="bi bi-person"></i> Profile Details
                              </h5>
                              <p className="smtext m-0 ms-3 me-5 mt-1 lh-1 text-secondary">
                                Manage your account information
                              </p>
                            </div>

                            <div className="col-lg-6 col-md-12">
                              <label className="label-text mb-1 ms-3">
                                Full Name <span className="text-danger">*</span>
                              </label>
                              <input
                                type="text"
                                name="name"
                                value={profile.name}
                                onChange={handleChange}
                                className="form-control ps-3 normal-text bg-white border border-light rounded-3"
                                placeholder="Enter Full Name"
                              />
                            </div>

                            <div className="col-lg-6 col-md-12">
                              <label className="label-text mb-1 ms-3">
                                Email ID <span className="text-danger">*</span>
                              </label>
                              <input
                                type="email"
                                name="email"
                                value={profile.email}
                                onChange={handleChange}
                                className="form-control ps-3 normal-text bg-white border border-light rounded-3"
                                placeholder="Enter Email ID"
                              />
                            </div>

                            <div className="col-lg-6 col-md-12">
                              <label className="label-text mb-1 ms-3">
                                Phone No <span className="text-danger">*</span>
                              </label>
                              <div className="d-flex align-items-center">
                                <input
                                  type="text"
                                  name="phone"
                                  value={profile.phone}
                                  onChange={handleChange}
                                  className="form-control ps-3 normal-text bg-white border border-light rounded-3"
                                  placeholder="Enter Phone No"
                                  readOnly
                                />
                                <div className="ms-2">
                                  <i className="bi bi-lock-fill"></i>
                                </div>
                              </div>
                            </div>

                            <div className="col-12">
                              <label className="label-text mb-1 ms-3">
                                Address
                              </label>
                              <textarea
                                name="address"
                                value={profile.address}
                                onChange={handleChange}
                                className="form-control ps-3 normal-text bg-white border border-light rounded-3"
                                rows="3"
                                placeholder="Enter Address"
                              />
                            </div>

                            {message && (
                              <p className="ms-2 mt-2 small text-success">
                                {message}
                              </p>
                            )}

                            <div className="col-lg-5 col-md-7 mt-4">
                              <button
                                type="submit"
                                className="btn btn-dark-primary border-0 px-4 rounded-3 fs-6 fw-medium"
                                disabled={saving}
                              >
                                {saving ? (
                                  <div
                                    className="spinner-border spinner-border-sm text-light"
                                    role="status"
                                  ></div>
                                ) : (
                                  "Save Changes"
                                )}
                              </button>
                            </div>
                          </div>
                        </form>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-5 col-12">
                    <div className="card bg-dark-primary rounded-4 shadow-none text-center border-0 w-100">
                      <div className="card-body py-4">
                        <img
                          src="https://geeksui.codescandy.com/geeks/assets/images/background/giftbox.png"
                          alt=""
                          width="70"
                        />
                        <div className="mt-3">
                          <h5 className="text-white mb-1 fs-6">
                            Unlimited Access
                          </h5>
                          <p className="text-white-50 fs-6 lh-sm mb-2">
                            Upgrade your plan from a Free trial to premium.
                          </p>
                          <Link
                            to="/pricing"
                            className="btn btn-white btn-sm mt-2 px-4 rounded-pill mb-2 fs-6"
                          >
                            Upgrade Now
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>

            <div className="col-lg-3 col-12">
              <Right />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default Settings;
